/* @ngInject */
export default function AiChatController (
  $element,
  $http,
  $interval,
  $scope,
  $timeout,
  alertLiteSvc,
  keycloakAdapterSvc
) {
  const vm = this

  vm.isChatHistory = false

  vm.message = ''
  vm.isAnswerLoading = false
  vm.fullSize = true
  vm.messages = []

  vm.conversationId = ''

  vm.chatErorr = false

  // --- loading phrases ---
  const loadingPhrases = [
    'Tuning the satellite dish...',
    'Buffering brilliance...',
    'Scanning the channel guide...',
    'Decoding the signal...',
    'Queuing up your answer...',
    'Adjusting the antenna...',
    'Streaming thoughts your way...',
    'Loading the EPG data...',
    'Syncing with the content library...',
    'Calibrating the bitrate...'
  ]
  vm.loadingPhrase = ''
  let loadingPhraseIndex = 0
  let loadingInterval = null

  function startLoadingPhrases () {
    if (loadingInterval) $interval.cancel(loadingInterval)
    loadingPhraseIndex = Math.floor(Math.random() * loadingPhrases.length)
    vm.loadingPhrase = loadingPhrases[loadingPhraseIndex]
    loadingInterval = $interval(function () {
      loadingPhraseIndex = (loadingPhraseIndex + 1) % loadingPhrases.length
      vm.loadingPhrase = loadingPhrases[loadingPhraseIndex]
    }, 3000)
  }

  function stopLoadingPhrases () {
    if (loadingInterval) {
      $interval.cancel(loadingInterval)
      loadingInterval = null
    }
    vm.loadingPhrase = ''
  }

  $scope.$on('$destroy', stopLoadingPhrases)

  vm.initHistoryState = {
    number: 0,
    size: 25
  }

  vm.historyState = angular.copy(vm.initHistoryState)

  // Function to decode Unicode sequences like uD83DuDCFA
  function decodeUnicodeSequences (text) {
    if (!text || typeof text !== 'string') return text

    // First, process surrogate pairs (two consecutive uXXXX sequences)
    // Find any two consecutive uXXXX sequences and check if they form a surrogate pair
    let result = text.replace(/u([0-9A-Fa-f]{4})u([0-9A-Fa-f]{4})/gi, (match, highHex, lowHex) => {
      try {
        const high = parseInt(highHex, 16)
        const low = parseInt(lowHex, 16)

        // Check if this is a surrogate pair
        if (high >= 0xD800 && high <= 0xDBFF && low >= 0xDC00 && low <= 0xDFFF) {
          // Calculate Unicode code point from surrogate pair
          const codePoint = (high - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000
          return String.fromCodePoint(codePoint)
        }
        // If not a surrogate pair, return original string for further processing
        return match
      } catch (e) {
        return match
      }
    })

    // Then process remaining single uXXXX sequences
    result = result.replace(/u([0-9A-Fa-f]{4})/gi, (match, hex) => {
      try {
        const code = parseInt(hex, 16)
        // Skip surrogate codes (already processed above as pairs)
        if (code >= 0xD800 && code <= 0xDFFF) {
          return match
        }
        return String.fromCharCode(code)
      } catch (e) {
        return match
      }
    })

    return result
  }

  vm.getChatHistory = function (resetState = false) {
    if (vm.isAnswerLoading) return

    if (resetState) {
      vm.historyState = angular.copy(vm.initHistoryState)
      vm.chatHistory = []
    } else {
      vm.historyState.number++
    }
    if (vm.historyState.last) return

    vm.isAnswerLoading = true
    vm.isChatHistory = true

    $http.get('api/assistant/conversations', {
      params: {
        page: vm.historyState.number,
        count: vm.historyState.size
      }
    })
      .then(res => {
        const payload = res.data.payload
        vm.chatHistory.push(...payload.content)
        vm.historyState.last = payload.last
      })
      .catch(err => {
        alertLiteSvc.error('Error: ' + err.message)
      })
      .finally(() => {
        vm.isAnswerLoading = false
      })
  }

  vm.closeAiChat = function () {
    $scope.$parent.vm.closeAiChat()
  }

  // --- autoscroll ---
  let autoScroll = true
  function getBody () {
    return $element[0].querySelector('.ai-chat-body')
  }
  function scrollToBottom (force = false) {
    const el = getBody()
    if (!el) return
    if (force || autoScroll) {
      $timeout(() => { el.scrollTop = el.scrollHeight }, 0, false)
    }
  }
  $timeout(() => {
    const el = getBody()
    if (!el) return
    el.addEventListener('scroll', () => {
      const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50
      autoScroll = nearBottom
    })
  }, 0, false)

  // --- send message ---
  vm.sendMessage = function (bindMessage) {
    if (bindMessage) {
      vm.message = bindMessage
    }
    if (!vm.message) return

    const message = vm.message
    vm.message = ''
    vm.isAnswerLoading = true
    startLoadingPhrases()

    vm.messages.push({ type: 'USER', text: message })
    const aiMessage = { type: 'ASSISTANT', text: '' }
    vm.messages.push(aiMessage)
    scrollToBottom(true)

    const queue = []
    let busy = false

    function pump () {
      if (busy || queue.length === 0) return
      busy = true
      aiMessage.text += queue.shift()
      $scope.$applyAsync()
      scrollToBottom()
      setTimeout(() => { busy = false; pump() }, 25)
    }

    const token = keycloakAdapterSvc.getToken() || window.localStorage.getItem('KEYCLOAK_TOKEN') || ''
    const headers = {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
      Accept: 'text/event-stream'
    }

    if (vm.conversationId) {
      headers['conversation-id'] = vm.conversationId
    }

    fetch('api/assistant/chat', {
      method: 'POST',
      headers,
      body: JSON.stringify({ message })
    })
      .then(res => {
        vm.isAnswerLoading = false
        stopLoadingPhrases()
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`)

        const conversationId = res.headers.get('conversation-id')
        if (conversationId) {
          vm.conversationId = conversationId
        }

        const contentType = res.headers.get('content-type')
        if (!contentType || !contentType.includes('text/event-stream')) {
          throw new Error('Expected text/event-stream response')
        }

        const reader = res.body.getReader()
        const decoder = new TextDecoder()

        function read () {
          return reader.read().then(({ done, value }) => {
            if (done) {
              $scope.$applyAsync()
              return
            }
            const chunk = decoder.decode(value, { stream: true }).replace(/\r/g, '')
            chunk.split('\n').forEach(line => {
              if (!line.startsWith('data:')) return
              if (line === '[DONE]') return
              if (line.trim().length === 0) {
                queue.push('\n')
              } else {
                let parsed
                // Try to parse SSE JSON payload with content and messageId; fallback to legacy slicing if not JSON
                try {
                  parsed = JSON.parse(line.slice(5).trim())
                } catch (e) {}

                if (parsed && (parsed.messageId || parsed.assistantMessageId)) {
                  aiMessage.id = parsed.messageId || parsed.assistantMessageId
                }
                if (parsed && typeof parsed.content === 'string') {
                  queue.push(decodeUnicodeSequences(parsed.content))
                } else if (!parsed || (!parsed.messageId && !parsed.assistantMessageId)) {
                  const cleanContent = line.slice(17, -2).replace(/\\n/g, '\n').replace(/\\/g, '')
                  queue.push(decodeUnicodeSequences(cleanContent))
                }
              }
              if (!busy) pump()
            })
            return read()
          })
        }
        return read()
      })
      .catch(err => {
        console.error('[AiChat] sendMessage failed:', err)
        aiMessage.text = "Sorry, I couldn't process your request right now. Please try again in a moment."
        aiMessage.error = true
        vm.isAnswerLoading = false
        stopLoadingPhrases()
        $scope.$applyAsync()
      })
  }

  vm.openConversation = function (conversationId) {
    vm.conversationId = conversationId
    vm.messages = []
    vm.isChatHistory = false

    if (!conversationId) { return }

    vm.isAnswerLoading = true

    $http.get(`api/assistant/conversations/${conversationId}/messages`)
      .then(res => {
        const messages = res.data.payload.content.reverse() || []
        vm.messages = messages.map(msg => ({
          ...msg,
          text: decodeUnicodeSequences(msg.text)
        }))
      })
      .catch(err => {
        alertLiteSvc.error('Error loading conversation: ' + err.message)
      })
      .finally(() => {
        vm.isAnswerLoading = false
      })
  }

  vm.onScroll = function (event, scrollToBottom) {
    if (!event) {
      return
    }

    if (event.wheelDelta < 0 && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.9) {
      scrollToBottom()
    }
  }

  vm.copyAnswer = function (message) {
    if (message.copied) return

    message.copied = true
    navigator.clipboard.writeText(message.text)
    $timeout(() => { message.copied = false }, 2000)
  }

  vm.setFeedback = function (message, rating) {
    if (!message || message.type !== 'ASSISTANT' || !message.id || !vm.conversationId || message.feedbackPending) return

    const newRating = message.feedbackRating === rating ? null : rating
    const prevRating = message.feedbackRating
    const prevTime = message.feedbackTime
    message.feedbackRating = newRating
    message.feedbackTime = new Date().toISOString()
    message.feedbackPending = true

    $http.patch(`api/assistant/conversations/${vm.conversationId}/messages/${message.id}/feedback`, {
      rating: newRating
    }).catch(err => {
      if (message.feedbackRating === newRating) {
        message.feedbackRating = prevRating
        message.feedbackTime = prevTime
      }
      alertLiteSvc.error('Error updating feedback: ' + (err.data?.message || err.message))
    }).finally(() => {
      message.feedbackPending = false
    })
  }
}
